import { ModuleWithProviders, NgModule } from '@angular/core';
import { AddressSearcherService } from '@df/ui/form/address-searcher.service';
import defaultsDeep from '@df/util/fn/defaults-deep';
import { DeepPartial } from '@df/util/type/deep-partial';
import { PcaAddressSearcherService } from './pca-address-searcher.service';
import { NPca } from './pca.interfaces';

@NgModule({
    providers: [
        {
            provide: AddressSearcherService,
            useClass: PcaAddressSearcherService
        }
    ]
})
export class PcaAddressSearcherModule {
    static forRoot(config?: DeepPartial<NPca.IModuleOptions>): ModuleWithProviders<PcaAddressSearcherModule> {
        return {
            ngModule: PcaAddressSearcherModule,
            providers: [
                {
                    provide: NPca.OPTIONS,
                    useFactory: () => {
                        return defaultsDeep(config, NPca.DEFAULT_OPTIONS);
                    }
                }
            ]
        };
    }
}
